import React from "react";
import { Col, Row, Container, Image } from "react-bootstrap";
import { DevelopmentData } from "../../db/DevelopmentData";
import "./DevelopmentContent.css";
import { Link } from "react-router-dom";
import ReactStars from "react-rating-stars-component";

function DevelopmentContent() {
  return (
    <div>
      <Container className="my-5">
        {DevelopmentData.map((item, index) => {
          return (
            <div className="blade">
              <Link to={item.path}>
                <Row>
                  <Col lg={4} md={4}>
                    <Image
                      className="part-img"
                      variant="top"
                      fluid
                      src={item.image}
                    />
                  </Col>
                  <Col lg={8} md={8} className="super-link">
                    <div className="partner-p">{item.title}</div>
                    <div className="partner-b">{item.desc}</div>
                    <div className="partner-a">{item.author}</div>
                    <div></div>
                    <div class="stary">
                      <span class="stary-p"> {item.rate}</span>
                      <div className="mask">
                        <ReactStars
                          count={5}
                          size={20}
                          activeColor="#eb8a2f"
                          value={item.rate}
                          isHalf={true}
                        />
                      </div>
                    </div>
                    <div className="part-price">RON {item.price}</div>
                    <div className="seller">{item.type}</div>
                  </Col>
                </Row>
              </Link>
              <hr
                style={{
                  height: 5,
                }}
              />
            </div>
          );
        })}
      </Container>
    </div>
  );
}

export default DevelopmentContent;
